import React from 'react';

import MenuItem from '@mui/material/MenuItem';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';

import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';

import noImage from './../images/noImage.png';


/* const theme = createTheme({
  overrides: {
    MuiInputLabel: { // Name of the component ⚛️ / style sheet
      root: { // Name of the rule
        color: "orange",
        borderColor: "orange",
        "&$focused": { // increase the specificity for the pseudo class
          color: "blue",
          borderColor: "blue",
        }
      }
    }
  }
}); */

class DropDown extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      edit: false,
      imageStatus: false,
      selectedValue: "",
      options: { },
      error: false
      /* onDark: false,
      textColor: "#47abff",
      labelColor: "#47abff" */
    };

    //this.handleExpandClick = this.handleExpandClick.bind(this);
    this.sendChangedState = this.sendChangedState.bind(this);
    
  }

  componentDidMount() {
    let value = 0;
    if ( this.props.value !== undefined ) value = this.props.value;
    this.setState ( {selectedValue: value} );
    if ( this.props.error !== undefined )
      this.setState ( { error: this.props.error } );
    /* if ( this.props.onDark ) {
      if ( this.props.onDark === true ) {
        this.setState ( { onDark : true } );
        this.setState ( { textColor : "#e3e3e5" } );
        this.setState ( { labelColor : "#e3e3e5" } );
      }
    } */
  }

  componentDidUpdate ( prevProps ) {    
    if ( prevProps.doReset !== this.props.doReset && this.props.doReset === true ){
      //this.setState({doReset: this.props.doReset })
      this.setState ( { imageStatus: false } );
    }

    if ( this.props.error !== undefined ) {
      if ( prevProps.error !== this.props.error )
        this.setState ( { error: this.props.error } );
    }
      
  }

  /* handleExpandClick ( ) {
    this.setState({ expanded: !this.state.expanded });
  } */

  sendChangedState ( e ) {
    this.setState ( {selectedValue: e.target.value} );
    /* let imageStatus = this.state.imageStatus;
    this.props.onClickFunction ( name, type );
    this.setState ( { imageStatus: !imageStatus } ); */

    if ( this.props.onChangeFunction ) {
      this.props.onChangeFunction ( e.target.value );
    }
  }

  render() {
    let doptions = {};
    let name = "undefined";
    let id = "";
    let values = [];
    let hasIcons = false;
    let minWidth=150;
    let maxWidth=200;
    let textColor = "#797979";
    let labelColor = "#797979";  
    let margin = 1;
    let marginTop = 0;
    let marginLeft = 0; 
   
    if ( this.props ) {
      if ( this.props.id !== undefined ) id = this.props.id;
      if ( this.props.doptions ) doptions = this.props.doptions;
      if ( this.props.name ) name = this.props.name;
      if ( this.props.hasIcons ) hasIcons = this.props.hasIcons;
      if ( this.props.minWidth ) minWidth = this.props.minWidth;
      if ( this.props.maxWidth ) maxWidth = this.props.maxWidth;
      if ( this.props.margin ) margin = this.props.margin;
      if ( this.props.marginTop ) marginTop = this.props.marginTop;
      if ( this.props.marginLeft ) marginLeft = this.props.marginLeft;
      //if ( this.props.onClickFunction ) onClickFunction = this.props.onClickFunction;
      //if ( this.props.values ) values = this.props.values;
    }

    if ( this.props.onDark === true ) {
      textColor = "#e3e3e5";
      labelColor = "#e3e3e5";
    }

    let dropDownOptions = null;
    if ( hasIcons === true ) {
      Object.keys(doptions).forEach((key) => values.push([key, doptions[key]]));
      dropDownOptions = values.map( (v) => {
        let img = noImage;
        if ( v[1]["image"] ) img = v[1]["image"];
        return <MenuItem sx={{display: "flex"}}
            key={v[0]} value={v[0]} id={id}>
            <Box sx={{ display: 'flex', flexDirection: 'row' }}>
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Avatar alt={v[1]["name"]} src={img} sx={{ display: 'flex', width: 24, height: 24 }}/>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', width: "70%", textAlign: "start", justifyContent:"left", marginLeft: "2px" }}>
                {v[1]["name"]}
              </Box>
            </Box>
          </MenuItem>
      });
    } else {
      Object.keys(doptions).forEach((key) => values.push([key, doptions[key]]));
      dropDownOptions = values.map( (v) => {
        return <MenuItem
          key={v[0]} value={v[0]} id={id}>{v[1]}
          </MenuItem>
      });
    }

    let selectedValue = "";
    if ( this.props.value !== undefined ) selectedValue = this.props.value;

    let size = "medium";
    if ( this.props.size ) size = this.props.size;
    
    return (

      <FormControl required sx={{ m: {margin}, marginTop: {marginTop}, marginLeft: {marginLeft}, minWidth: {minWidth}, maxWidth: {maxWidth}, display: 'inline-flex', color: textColor, borderColor: {textColor} }} >
        <InputLabel id="demo-simple-select-required-label" sx={{color: {labelColor}}}>{name}</InputLabel>
        <Select
          labelId="demo-simple-select-required-label"
          id={id}
          value={selectedValue} /* {this.state.selectedValue} */
          label={name + "*"}
          onChange={this.sendChangedState}
          sx={{display: "flex", color: {textColor}, minWidth: {minWidth} }}
          size={size}
          required={true}
          error={this.state.error}
          /* inputProps={{ style: { borderColor: "#FF0000 !important" } }}
          SelectDisplayProps={{ style: { borderColor: "#FF0000 !important" } }} */
          /* inputLabelProps = {{ sx : { color: textColor } }} */
        >
          {dropDownOptions}
          {/* <MenuItem value="">
            <em>None</em>
          </MenuItem>
          <MenuItem value={10}>Ten</MenuItem>
          <MenuItem value={20}>Twenty</MenuItem>
          <MenuItem value={30}>Thirty</MenuItem> */}
        </Select>
      </FormControl>

   
    );

  }
}

export default DropDown;
